import type { DataProxy } from "@apollo/client";
import AssetDiscussionCommentByShortId from "../../../lib/graphql/queries/discussions/AssetDiscussionCommentByShortId";
import type {
  IAssetDiscussionCommentByShortIdQuery,
  IAssetDiscussionCommentByShortIdQueryVariables,
} from "../../../lib/graphql/queries/discussions/__generated__/AssetDiscussionCommentByShortId.generated";

type TRootQueryData = IAssetDiscussionCommentByShortIdQuery["assetDiscussionCommentByShortId"];

export default function transformOnSingleCommentRootQuery(
  dataProxy: DataProxy,
  commentShortId: string,
  transform: (rootQueryData: TRootQueryData) => TRootQueryData,
) {
  try {
    const queryData = dataProxy.readQuery<
      IAssetDiscussionCommentByShortIdQuery,
      IAssetDiscussionCommentByShortIdQueryVariables
    >({
      query: AssetDiscussionCommentByShortId,
      variables: {
        commentShortId,
      },
    });

    if (!queryData) {
      return;
    }

    if (!queryData.assetDiscussionCommentByShortId) {
      return;
    }

    const transformResult = transform(queryData.assetDiscussionCommentByShortId);

    if (transformResult === null) {
      dataProxy.writeQuery<IAssetDiscussionCommentByShortIdQuery, IAssetDiscussionCommentByShortIdQueryVariables>({
        query: AssetDiscussionCommentByShortId,
        variables: {
          commentShortId,
        },
        data: {
          __typename: "Query",
          assetDiscussionCommentByShortId: null,
        },
      });

      return;
    }

    dataProxy.writeQuery<IAssetDiscussionCommentByShortIdQuery, IAssetDiscussionCommentByShortIdQueryVariables>({
      query: AssetDiscussionCommentByShortId,
      variables: {
        commentShortId,
      },
      data: {
        __typename: "Query",
        assetDiscussionCommentByShortId: {
          ...queryData.assetDiscussionCommentByShortId,
          ...transform(queryData.assetDiscussionCommentByShortId),
        },
      },
    });
  } catch (err) {} // eslint-disable-line
}
